define('map',[], function(){
    "use strict";
    var map = {};

    /*
		TODO:
			- Dynamically create views and marker collections that correspond to one another
    */

    map.current = null;

    map.infowindow = null;

    // Merchant In-Store
    map.merchantView = null;
    map.merchantViewMarkerCollection = {};
    
    // Merchant In-Store Detail
    map.merchantDetailView = null;
    map.merchantDetailViewMarkerCollection = {};

    map.resetMerchantViewCollection = function(collection){
    	collection = {};
    };

    return map;
});
